module.exports = __webpack_public_path__ + "img/selected4-min.37fc0c35.png";